module.exports = __webpack_public_path__ + "static/media/nappydannyshop.f56a1ccd.png";